﻿"use strict";

const tabbed = {
  tablist: null,
  tabs: [],
  panels: [],
  setTablist: function() {
    var lists = Array.from(document.querySelectorAll("[data-tab-nav]")).filter(
      nav => nav.querySelectorAll("[data-tab-link]").length > 0
    );
    if (lists.length > 0) {
      this.tablist = lists[0];
      this.tablist.setAttribute("role", "tablist");
      this.setTabs();
    }
  },
  setTabs: function() {
    if (this.tablist != null) {
      this.tabs = this.tablist.querySelectorAll("[data-tab-link]");
      this.setPanels();
    }
  },
  setPanels: function() {
    if (this.tabs.length > 0) {
      this.panels = Array.from(this.tabs).map(tab =>
        document.querySelectorAll("[data-tab]" + tab.getAttribute("href"))
      );
    }
  },
  switchTab: function(oldTab, newTab) {
    if (oldTab == null) {
      let currentTab = document.querySelector("[data-tab-link][aria-selected]");
      if (currentTab != null) {
        this.switchTab(currentTab, newTab);
      } else {
        this.switchTab(newTab, newTab);
      }
      return;
    }

    oldTab.classList.remove("active");
    oldTab.removeAttribute("aria-selected");
    oldTab.setAttribute("tabindex", "-1");

    newTab.focus();
    // Make the active tab focusable by the user (Tab key)
    newTab.removeAttribute("tabindex");
    // Set the selected state
    newTab.setAttribute("aria-selected", "true");
    newTab.classList.add("active");

    var currentButton = this.tablist.querySelector(
      ".content-nav__item--current"
    );
    if (currentButton != null) {
      currentButton.innerText = newTab.innerText;
    }
    // Get the indices of the new and old tabs to find the correct
    // tab panels to show and hide
    let index = Array.prototype.indexOf.call(this.tabs, newTab);
    let oldIndex = Array.prototype.indexOf.call(this.tabs, oldTab);
    this.panels[oldIndex][0].hidden = true;
    this.panels[index][0].hidden = false;

    history.pushState(null, newTab.innerText, newTab.getAttribute("href"));
  },
  init: function() {
    this.setTablist();

    if (this.tablist == null) {
      return;
    }

    var that = this;

    // Add semantics are remove user focusability for each tab
    Array.prototype.forEach.call(that.tabs, (tab, i) => {
      tab.setAttribute("role", "tab");
      tab.setAttribute("id", "tab" + (i + 1));
      tab.setAttribute("tabindex", "-1");
      tab.parentNode.setAttribute("role", "presentation");

      // Handle clicking of tabs for mouse users
      tab.addEventListener("click", e => {
        e.preventDefault();
        let currentTab = that.tablist.querySelector("[aria-selected]");
        if (e.currentTarget !== currentTab) {
          that.switchTab(currentTab, e.currentTarget);
        }
      });

      // Handle keydown events for keyboard users
      tab.addEventListener("keydown", e => {
        // Get the index of the current tab in the tabs node list
        let index = Array.prototype.indexOf.call(that.tabs, e.currentTarget);
        // Work out which key the user is pressing and
        // Calculate the new tab's index where appropriate
        let dir =
          e.which === 37
            ? index - 1
            : e.which === 39
            ? index + 1
            : e.which === 40
            ? "down"
            : null;
        if (dir !== null) {
          e.preventDefault();
          // If the down key is pressed, move focus to the open panel,
          // otherwise switch to the adjacent tab
          dir === "down"
            ? panels[i].focus()
            : that.tabs[dir]
            ? switchTab(e.currentTarget, that.tabs[dir])
            : void 0;
        }
      });
    });

    // Add tab panel semantics and hide them all
    Array.prototype.forEach.call(that.panels, (panel, i) => {
      panel[0].setAttribute("role", "tabpanel");
      panel[0].setAttribute("tabindex", "-1");
      let id = panel[0].getAttribute("id");
      panel[0].setAttribute("aria-labelledby", that.tabs[i].id);
      panel[0].hidden = true;
    });

    let selectedTab = false;

    if (!selectedTab) {
      // Initially activate the first tab and reveal the first tab panel
      that.tabs[0].removeAttribute("tabindex");
      that.tabs[0].setAttribute("aria-selected", "true");
      that.panels[0][0].hidden = false;
    }

    if (window.location.hash != "") {
      var currentTabs = Array.from(that.tabs).filter(function(tab) {
        return tab.getAttribute("href") == window.location.hash;
      });

      if (currentTabs.length > 0) {
        that.switchTab(null, currentTabs[0]);
        //window.scrollTo(0, 0);
        //setTimeout(() => window.scrollTo(0, 0), 10);
      }
    }

    Array.from(
      document.querySelectorAll(
        'a[href^="' +
          window.location.pathname +
          '#"]:not(data-tab-link), a[href^="#"]:not(data-tab-link)'
      )
    ).forEach(link => {
      link.addEventListener(
        "click",
        () => {
          var id = link.getAttribute("href");
          id = id.substring(id.indexOf("#"));
          var currentTabs = Array.from(that.tabs).filter(function(tab) {
            return tab.getAttribute("href") == id;
          });
          if (currentTabs.length > 0) {
            that.switchTab(null, currentTabs[0]);
            //window.scrollTo(0, 0);
            //setTimeout(() => window.scrollTo(0, 0), 10);
          }
        },
        false
      );
    });
  }
};

module.exports = tabbed.init();
